<div class="grid-container padding-bottom-4">
  <div class="grid-row">
    <div class="grid-col-10">
      <legend class="usa-legend usa-legend--large">FRT OTO - Control Screen</legend>
    </div>
  </div>
  <div class="grid-row grid-gap-2" *ngIf="otoRequest">
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-5 desktop:grid-col-5">
      <legend class="usa-legend usa-legend--medium">Shipment Information</legend>
      <div class="grid-row grid-gap-2 padding-y-05">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          Request Date:
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
          {{ otoRequest.requestDateTime}}
        </div>
      </div>
      <div class="grid-row grid-gap-2 padding-y-05">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          Quote Date:
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
          {{ otoRequest.quoteDateby}}
        </div>
      </div>
      <div class="grid-row grid-gap-2 padding-y-05">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          Pickup Date:
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
          {{ otoRequest.pickupDate}}
        </div>
      </div>
      <div class="grid-row grid-gap-2 padding-y-05">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          Pickup Date:
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
          {{ otoRequest.requiredDeliveryDate}}
        </div>
      </div>
      <div class="grid-row grid-gap-2 padding-y-05">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          Expedite Freight Shipment:
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
          {{ otoRequest.expediteFreightShipment}}
        </div>
      </div>
      <div class="grid-row grid-gap-2 padding-y-05">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          Declared Shipment Value:
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
          {{ otoRequest.declaredShipmentValue}}
        </div>
      </div>
      <legend class="usa-legend usa-legend--medium">Agency Information</legend>
      <div class="grid-row grid-gap-2 padding-y-05">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          Agency Name:
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
          {{carrier ? carrier.scac : ''}}
        </div>
      </div>
      <div class="grid-row grid-gap-2 padding-y-05">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          Phone:
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
          {{carrierOrganizationInfo ? carrierOrganizationInfo.phone : ''}}
        </div>
      </div>
      <div class="grid-row grid-gap-2 padding-y-05">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
          Email:
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-8 desktop:grid-col-8">
          {{carrierOrganizationInfo? carrierOrganizationInfo.email : ''}}
        </div>
      </div>
      <div class="grid-row grid-gap-1 padding-y-05">
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
          <legend class="usa-legend usa-legend--medium">Origin</legend>
          <div>{{otoRequest.originZipId}}</div>
          <div>{{originAddress}}</div>
          <div>{{originCountry}}</div>
        </div>
        <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-6 desktop:grid-col-6">
          <legend class="usa-legend usa-legend--medium">Destination</legend>
          <div>{{otoRequest.destinationZipId}}</div>
          <div>{{destinationAddress}}</div>
          <div>{{destinationCountry}} </div>
        </div>
      </div>
    </div>
  </div>
  <form *ngIf="isCarrierView" [formGroup]="otoBidForm" class="grid-row grid-gap-2">
    <div class="grid-col-12 tablet:grid-col-4">

        <label for="shipper" class="usa-label">Bid amount <abbr title="required"
                                                               class="usa-hint usa-hint--required">*</abbr></label>
        <input type="text" id="shipper" required class="usa-input" formControlName="bidAmount" size='250'
               maxlength='250'>
        @if (this.otoBidForm.get('bidAmount').invalid && (this.otoBidForm.get('bidAmount').touched || this.otoBidForm.get('bidAmount').dirty) && this.otoBidForm.get('bidAmount').errors.required) {
          <div class="alert"
          >
            <small class="text-danger">
              <span class="fa fa-warning"></span> This field is required
            </small>
          </div>
        }
    </div>
    <div class="grid-col-12 mobile-lg:grid-col-12 tablet:grid-col-4 desktop:grid-col-4">
      <label class="usa-label" for="oto-tsp-comments">TSP Comments</label>
      <textarea id="oto-tsp-comments" class="usa-textarea" maxlength="300" formControlName="tspComments"></textarea>
    </div>
    <div class="grid-col-12">
      <button type="button" class="usa-button" (click)="submitOtoBid()">Submit</button>
    </div>
  </form>
</div>
